import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  EventEnrollRequestData,
  EventEnrollResponseData,
  EventEnrollUserRequestData,
  EventEnrollUserSessionResponseData,
} from 'src/app/@data-services/event-enroll/event-enroll.data-model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EventEnrollDataService {
  private readonly _http = inject(HttpClient);

  updateEnrolledUser(
    requestData: EventEnrollRequestData
  ): Observable<EventEnrollResponseData> {
    return this._http.post<EventEnrollResponseData>(
      environment.apiUrl + '/r1/config',
      requestData
    );
  }

  createEnrolledUserSession(
    requestData: EventEnrollUserRequestData
  ): Observable<EventEnrollUserSessionResponseData> {
    return this._http.post<EventEnrollUserSessionResponseData>(
      environment.apiUrl + '/r1/config',
      requestData
    );
  }
}
